export function getAwards2GisLink(): string {
    return 'https://awards.2gis.ru/';
}
